// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"f868105a","552":"e41659e2","784":"aad8e7e4","817":"82ec8473","959":"feef69a4","962":"498f65b4"}[chunkId] + ".chunk.js";
};